<template>
  <div :dir="$dir.ltr ? 'ltr' : 'rtl'" class="app flex-row align-items-center" :class="{'text-left': $dir.ltr, 'text-right': $dir.rtl}">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-6">
          <img class="d-block mx-auto mb-4" src="/img/404.png" />
          <div class="clearfix">
            <h1 class="display-3 mr-4" :class="{'float-right': $dir.ltr, 'float-left': $dir.rtl}">404</h1>
            <h4 class="pt-3">{{ $t('shared.oopsYouAreLost') }}</h4>
            <p class="text-muted">{{ $t('shared.thePageYouAreLookingForWasNotFound') }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Page404'
}
</script>